import { render } from "./Privacy.vue?vue&type=template&id=7012b6e3&scoped=true&ts=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"

import "./Privacy.vue?vue&type=style&index=0&id=7012b6e3&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7012b6e3"]])

export default __exports__